import PropTypes from "prop-types";
import { StatusBar } from "expo-status-bar";
import React from "react";
import ENV from "app/utils/ENV";
import {
  StyleSheet,
  View,
  ScrollView,
  Platform,
  TouchableOpacity,
  UIManager,
  ActivityIndicator,
  TextInput,
} from "react-native";
import * as RootNavigation from "app/utils/RootNavigation.js";
import Text from "app/components/Text";
import Value from "app/components/Value";
import apiActions from "app/utils/apiActions";
import valueActions from "app/utils/valueActions";
import textHelpers from "app/utils/textHelpers";
import valueHelpers from "app/utils/valueHelpers";
import iconHelpers from "app/utils/iconHelpers";
import { styleSheet, colors, sizes, WIDTH } from "app/utils/styleSheet";
import Autocomplete from "app/components/Autocomplete";
import DatePicker from "app/components/DatePicker";
import ValueListItem from "app/components/ValueListItem";
import Icon from "app/components/Icon";

import SwipeableItem from "react-native-swipeable-item";
import Animated from "react-native-reanimated";
const { multiply, sub } = Animated;

import { Ionicons, Feather, Entypo } from "@expo/vector-icons";

import store from "app/redux/store";

import { TouchableOpacity as RNGHTouchableOpacity } from "react-native-gesture-handler";
const isAndroid = Platform.OS === "android";
if (isAndroid && UIManager.setLayoutAnimationEnabledExperimental) {
  UIManager.setLayoutAnimationEnabledExperimental(true);
}
const PlatformTouchable = isAndroid ? TouchableOpacity : TouchableOpacity;

export default class QuickComposer extends React.Component {
  static propTypes = {
    onSubmit: PropTypes.func,
  };

  constructor(props) {
    super(props);
    this.state = this.initialState();
  }

  initialState = () => {
    let { app, values } = store.getState();
    return {
      value: {
        text: "",
        color: "",
        icon: "",
        parent_ids: [],
        progress_at: [],
      },
      parents: [],
      children: [],
      values,
      submitting: false,
      composing: false,
      nameQuery: "",
      parentQuery: "",
      childQuery: "",
      showMore: false,
      showIconSelector: false,
      showColorSelector: false,
      formIsDirty: false,
    };
  };

  render() {
    if (ENV.WEB) return null;

    let { composing } = this.state;

    let item = {
      key: "composer",
      hasLeft: true,
      hasRight: true,
    };

    let listWidth = Math.min(WIDTH, 500);

    return (
      <View style={{ marginTop: sizes.base }}>
        <SwipeableItem
          key={"composer"}
          item={{ item }}
          overSwipe={50}
          snapPointsLeft={item.hasLeft ? [50, listWidth] : undefined}
          snapPointsRight={item.hasRight ? [100, listWidth] : undefined}
          renderOverlay={(params) => this.renderComposer(params)}
        />
      </View>
    );
  }

  renderComposer = (params) => {
    let { item, openLeft, openRight, openDirection, close } = params;
    let { fetching, onPress } = this.props;
    let {
      value,
      submitting,
      parentQuery,
      childQuery,
      nameQuery,
      showMore,
      composing,
      showIconSelector,
      showColorSelector,
      formIsDirty,
      values,
    } = this.state;

    let suggestions = textHelpers.suggestions(nameQuery, values);
    suggestions = valueHelpers.filterToCurrentRevisions(suggestions);
    suggestions = valueHelpers.filterToActive({
      values: suggestions,
      removeHidden: false,
      removeSubTasks: false,
    });
    suggestions = valueHelpers.filterToCurrentRevisions(suggestions);

    return (
      <View style={styles.wrapper}>
        <ValueListItem
          pointerEvents={this.props.pointerEvents}
          composingColor={value.color}
          value={value}
          icon={fetching ? "spinner" : composing ? "select" : "search"}
          iconColor={colors.inactive}
          loading={submitting}
          style={[
            !ENV.DARK && { backgroundColor: colors.subtle },
            composing && !value.color ? styles.composingRow : null,
          ]}
          onPress={() => {
            if (openDirection) close();
            else if (onPress) onPress();
            else if (!!this.input) this.input.focus();
          }}
          onPressIcon={() => {
            if (!composing) {
              if (!!this.input) this.input.focus();
            } else {
              this.setState({
                showIconSelector: true,
                showColorSelector: false,
              });
            }
          }}
          hideButtons={!composing}
          customCancelButton={(style, color) => (
            <Feather
              name={"trash-2"}
              style={style}
              color={color}
              onPress={async () => {
                if (formIsDirty) {
                  let confirm = await valueActions.confirm("discard");
                  if (!confirm) return;
                }
                this.setState(this.initialState());
              }}
            />
          )}
          customSubmitButton={(style, color) => (
            <Ionicons
              name={"md-add-circle-outline"}
              style={style}
              color={color}
              onPress={async () => {
                if (this.validate()) {
                  let confirm = await valueActions.confirm("submit");
                  if (!confirm) return;
                  this.onCreate();
                }
              }}
            />
          )}
          renderButton={(style) => {
            if (composing) {
              return this.renderColorSelector(style);
            } else if (!!nameQuery.length) {
              return (
                <Feather
                  name={"edit"}
                  color={colors.lightForeground}
                  style={style}
                  onPress={() => this.setState({ composing: true })}
                />
              );
            }
          }}
          renderText={() => (
            <Autocomplete
              autoFocus
              inputRef={(c) => (this.input = c)}
              placeholder={"search or create"}
              placeholderTextColor={colors.placeholder}
              value={value.text}
              extraStyle={styles.bigInput}
              data={suggestions}
              onCancel={() => this.setState(this.initialState())}
              onSubmit={() => {
                if (suggestions.length) this.onSubmit(suggestions[0]);
                else this.setState({ composing: true });
              }}
              onChangeText={(text) => {
                this.setState({ nameQuery: text });
                this.onChangeValue("text", text);
              }}
              renderItem={({ item, i }) => (
                <PlatformTouchable
                  key={i}
                  onPress={() => this.onSubmit(item)}
                  style={styles.suggestionWrapper}
                >
                  <Text style={{ padding: sizes.small }}>{item.text}</Text>
                  <Entypo
                    name={"chevron-right"}
                    color={colors.foreground}
                    style={styles.icon}
                    onPress={() => {
                      this.setState({ nameQuery: "" });
                      this.onChangeValue("text", "");
                      RootNavigation.push("Value", { id: item.id });
                    }}
                  />
                </PlatformTouchable>
              )}
            />
          )}
          renderFooter={() => {
            if (showIconSelector) {
              return (
                <View>
                  <Text italic style={{ padding: sizes.base }}>
                    leave icon blank to inherit from closest parent
                  </Text>
                  <View
                    style={[styles.selectorRow, { alignSelf: "flex-start" }]}
                  >
                    {iconHelpers.iconOptions().map((icn, i) => (
                      <PlatformTouchable
                        key={i}
                        style={styles.selectable}
                        onPress={() =>
                          this.onChangeValue("icon", icn == "select" ? "" : icn)
                        }
                      >
                        <Icon
                          name={icn}
                          color={value.color || colors.foreground}
                        />
                      </PlatformTouchable>
                    ))}
                  </View>
                </View>
              );
            } else if (showColorSelector) {
              return (
                <View>
                  <Text italic style={{ padding: sizes.base }}>
                    leave color blank to inherit from ancestors
                  </Text>
                  <View style={[styles.selectorRow, { alignSelf: "flex-end" }]}>
                    {valueHelpers.colorOptions().map((c, i) => (
                      <PlatformTouchable
                        key={i}
                        style={styles.selectable}
                        onPress={() => this.onChangeValue("color", c)}
                      >
                        <View
                          style={[
                            styles.colorDot,
                            { backgroundColor: valueHelpers.colorAsHex(c) },
                          ]}
                        />
                      </PlatformTouchable>
                    ))}
                  </View>
                </View>
              );
            }
          }}
        />

      </View>
    );
  };

  renderColorSelector = (style) => {
    let { value, showColorSelector } = this.state;
    return (
      <View style={style}>
        <PlatformTouchable
          onPress={() =>
            this.setState({
              showColorSelector: !showColorSelector,
              showIconSelector: false,
            })
          }
        >
          <View
            style={[
              styles.colorDot,
              !value.color
                ? {
                    borderWidth: 2,
                    borderColor: colors.trim,
                  }
                : {
                    borderWidth: 2,
                    borderColor: colors.lightForeground,
                    backgroundColor: valueHelpers.colorAsHex(value.color),
                  },
            ]}
          />
        </PlatformTouchable>
      </View>
    );
  };

  validate = () => {
    let { value, submitting } = this.state;
    let valid = true;
    if (submitting) valid = false;
    else if (!!!value.text) valid = false;
    return valid;
  };

  onChangeValue = (key, val) => {
    let { value } = this.state;
    value[key] = val;
    this.setState({
      value,
      showIconSelector: false,
      showColorSelector: false,
      formIsDirty: true,
    });
  };

  selectParent = (parent) => {
    let { value } = this.state;
    let { values } = this.props;
    let parent_ids = value.parent_ids;
    if (parent_ids.includes(parent.id)) {
      parent_ids.splice(parent_ids.indexOf(parent.id), 1);
    } else {
      parent_ids.push(parent.id);
    }
    let parents = values.filter((v) => parent_ids.includes(v.id));
    this.onChangeValue("parent_ids", parent_ids);
    this.setState({ parentQuery: "", parents });
  };

  selectChild = (child) => {
    let { value, children } = this.state;
    let child_ids = children.map((c) => c.id);
    if (child_ids.includes(child.id)) {
      child_ids.splice(child_ids.indexOf(child.id), 1);
      children.splice(
        children.findIndex((c) => c.id == child.id),
        1
      );
    } else {
      child_ids.push(child.id);
      children.push(child);
    }
    this.setState({ childQuery: "", children });
  };

  selectValue = (value) => {
    this.setState({ nameQuery: "" });
    this.props.onChangeValue("value", value);
  };

  onSubmit = (value) => {
    this.setState(this.initialState());
    let { onSubmit } = this.props;
    onSubmit(value);
  };

  onCreate = async () => {
    let { value } = this.state;
    this.setState({ submitting: true });
    value = await valueActions.create(value);
    this.setState({ submitting: false });
    this.setState(this.initialState());
    this.props.onSubmit(value);
  };
}

const styles = StyleSheet.create({
  wrapper: {
    alignItems: "stretch",
    justifyContent: "flex-start",
  },
  inputRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    flexWrap: "nowrap",
    minHeight: sizes.large * 2 + sizes.itemHeight,
  },
  composingRow: {
    borderWidth: 1,
    borderColor: colors.trim,
  },
  bigInput: {
    color: colors.foreground,
    backgroundColor: "transparent",
    textAlignVertical: "center",
    height: sizes.itemHeight,
  },
  input: {
    ...styleSheet.input,
    flex: 1,
  },
  topButtonWrapper: {
    marginRight: sizes.large,
    flexDirection: "row",
    justifyContent: "flex-end",
    alignItems: "center",
  },
  buttonIcon: {
    fontSize: sizes.itemHeight,
    marginLeft: sizes.large,
  },
  buttonWrapper: {
    zIndex: -1,
    flexDirection: "row",
    justifyContent: "space-between",
    marginLeft: sizes.large,
  },
  selectorRow: {
    flexDirection: "row",
    flexWrap: "wrap",
  },
  selectable: {
    width: sizes.itemHeight + sizes.small * 2,
    height: sizes.itemHeight + sizes.small * 2,
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: colors.fill,
    borderColor: colors.fill,
    borderWidth: 1,
    borderRadius: sizes.small,
    margin: sizes.small,
    padding: sizes.small,
  },
  colorDot: {
    width: sizes.itemHeight,
    height: sizes.itemHeight,
    borderRadius: sizes.itemHeight / 2,
  },
  underlayRow: {},
  underlayRight: {},
  suggestionWrapper: {
    padding: sizes.base,
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  icon: {
    fontSize: sizes.itemHeight,
  },
});
